angular.module('unergie.main')
.controller('energyCheckModalCtrl', ($scope, $uibModalInstance, $filter, account, DataAccess, BarcodeService, AlertManager, ErrorCatcher) => {
    $scope.close = $uibModalInstance.dismiss

    $scope.fillEnergyCheckWithQrCode = BarcodeService.fillEnergyCheckWithQrCode
    $scope.fillEnergyCheckWithDataMatrix = BarcodeService.fillEnergyCheckWithDataMatrix

    $scope.energyCheckPayload = {
        type: null,
        amount: undefined,
        check_date: moment().format('DDMMYYYY'),
        validity_date: undefined,
        external_id: '',
        id_account: account.id,
        pre_allocated: undefined,
    }

    $scope.isValidityDateOk = () => {
        return $scope.energyCheckPayload.validity_date && moment($scope.energyCheckPayload.validity_date, 'DDMMYYYY').isAfter(moment().add(-1, 'month'))
    }

    $scope.canSave = () => {
        return ((!!$scope.energyCheckPayload.amount &&
                !!$scope.energyCheckPayload.external_ref_1 &&
                !!$scope.energyCheckPayload.external_ref_2 &&
                !!$scope.energyCheckPayload.external_id_key &&
                $scope.isValidityDateOk())
            || $scope.energyCheckPayload.type === 'CERTIFICATE') &&
        !!$scope.energyCheckPayload.external_id &&
        !!$scope.energyCheckPayload.check_date &&
        !!$scope.energyCheckPayload.validity_date &&
        ($scope.energyCheckPayload.pre_allocated != null || $scope.energyCheckPayload.type === 'CERTIFICATE')
    }

    $scope.save = () => {
        $scope.saving = true
        const payload = _.cloneDeep($scope.energyCheckPayload)
        payload.check_date = moment(payload.check_date, 'DDMMYYYY').format('YYYY-MM-DD')
        payload.validity_date = moment(payload.validity_date, 'DDMMYYYY').format('YYYY-MM-DD')
        if (payload.type === 'CERTIFICATE') {
            payload.pre_allocated = undefined
        }
        return DataAccess.saveEnergyCheck(payload).$promise.then(() => {
            AlertManager.success(payload.type === 'CHECK' ? 'Chèque énergie enregistré' : 'Attestation enregistrée')
            $scope.done()
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.saving = false
        })
    }

    document.onkeydown = BarcodeService.handleEvent(BarcodeService.fillEnergyCheckBackCompatible, $scope.energyCheckPayload)

    $scope.done = $uibModalInstance.close
})
